// extracted by mini-css-extract-plugin
module.exports = {"next":"Breadcrumb_next__IY8f_"};